import { EditorState } from '@tiptap/pm/state';
import { cellAround, selectedRect } from '@tiptap/pm/tables';

export const mergeCellsDisabled = (state: EditorState) => {
  const cellPos = cellAround(state.selection.$from);
  if (!cellPos) return true;
  const rect = selectedRect(state);
  if (!rect) return true;
  return !(Math.abs(rect.top - rect.bottom) > 1 || Math.abs(rect.left - rect.right) > 1);
};
